import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";

import { 
  Radio, 
  RadioGroup, 
  TextField, 
  FormControlLabel,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";

import { 
  Operation, 
  Categories,
  POSEIDON_CONDITION,
} from "../../pages/SEGMENT/poseidon/SegmentModel";

// import json1 from './json1.json'

const twoSelectWidth: string = "47%";
const threeSelectWidth: string = "31%";

let AllCategory = getCategory();
let FirstCategoryAndLabel: any = [];

// @ts-ignore
export const Internal1 = ({ removeComponents, cmp1, control, condition, type, editId, bdopen }) => {
    const [component2, setComponent2] = useState([1]);
  
    function addComponents2() {
      setComponent2(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
    };
  
    function removeComponents2(index: number) {
      setComponent2(current => [...current.filter(i => i !== index)]);
    };
  
    const [andOr, setAndOr] = useState("AND");
    const [isChange, setIsChange] = useState(false);
  
    useEffect(() => {
      if (editId === "0" || condition === undefined || !bdopen) {
        return;
      }
  
      setIsChange(!isChange);
      setAndOr(condition.operation);
  
      for (var i=0; i < condition.itemConditions.length-1; i++) {
        addComponents2();
      };
    }, []);
  
    return (
      <>
        <div style={{
          background: "#F8F5F2", 
          padding: "15px", 
          borderRadius: "10px"
        }}>
          <div style={{display: "flex"}}>
            <Link to="#" onClick={() => removeComponents(cmp1)} style={{marginTop: "13px", marginRight: "5px"}}>
              <CloseIcon />
            </Link>
            <p style={{marginRight: "10px"}}>結合条件</p>
            <Controller
              name={`${type}-${cmp1}_InnerAndOr`}
              control={control}
              key={isChange ? "Loading" : "Loaded"}
              defaultValue={andOr}
              as={
                <RadioGroup row aria-label="position" name="position">
                  <FormControlLabel
                    value={Operation.And}
                    control={
                      <Radio 
                        color="primary"
                        checked={andOr === Operation.And ? true : false}
                        onClick={() => {
                          setAndOr(Operation.And)
                        }}
                      />
                    }
                    label={Operation.And}
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value={Operation.Or}
                    control={
                      <Radio 
                        color="primary"
                        checked={andOr === Operation.Or ? true : false}
                        onClick={() => {
                          setAndOr(Operation.Or)
                        }}
                      />
                    }
                    label={Operation.Or}
                    labelPlacement="end"
                  />
                </RadioGroup>
              }
            />
          </div>
          <br />
          { 
            component2 ?
            component2.map((cmp2: string | number | null | undefined, index: number) =>
              <Internal2 
                key={`${type}-${cmp2}`}
                removeComponents2={removeComponents2}
                cmp1={cmp1}
                cmp2={cmp2}
                control={control}
                items={(editId !== "0" && condition !== undefined) ? condition.itemConditions[index] : ""}
                type={type}
                editId={editId}
                bdopen={bdopen}
              />
            ) : ""
          }
        </div>
        <br />
        <Tooltip title="条件を追加" placement="top">
          <Fab 
            color="default" 
            aria-label="add" 
            style={{
              marginLeft: "15px",
              marginTop: "-40px",
              marginBottom: "20px"
            }}
          >
            <Link to="#" onClick={addComponents2}>
              <AddIcon/>
            </Link>
          </Fab>
        </Tooltip>
        <br />
      </>
    );
};
  
// @ts-ignore
const Internal2 = ({ removeComponents2, cmp1, cmp2, control, items, type, editId, bdopen }) => {
    if (AllCategory.length <= 0) {
      AllCategory = getCategory();
    }

    if (FirstCategoryAndLabel.length <= 0) {
      AllCategory.forEach(function (ac1: any) {
        FirstCategoryAndLabel.push({
          category: ac1[0].category,
          categoryLabel: ac1[0].categoryLabel,
        });
      });
    }
    
    // First Select
    const [selectFirst, setSelectFirst] = useState(AllCategory[0][0].category as string);
    
    // subCategoryなし
    const [selectSecond, setSelectSecond] = useState(AllCategory[0][0].subSubcategory as string);
    // subCategoryあり
    const [selectSecond3, setSelectSecond3] = useState("");
    const [selectThird3, setSelectThird3] = useState("");

    // change
    const [isChangeFirst, setIsChangeFirst] = React.useState(true);
    const [isChangeSecond, setIsChangeSecond] = React.useState(true);
    const [isChangeThird, setIsChangeThird] = React.useState(true);

    const initCategories: Categories = {
      category: AllCategory[0][0].category,
      attributes: AllCategory[0][0].attributes,
      field: AllCategory[0][0].field,
    };

    const [category, setCategory] = React.useState<Categories>(initCategories);
    const [categorySecond, setCategorySecond] = React.useState([]);

    const [listCategories, setListCategories] = React.useState(AllCategory[0]);
    const [listCategories3, setListCategories3] = React.useState([]);

    // 3番目のselectが存在するか
    const [existsThirdSelection, setExistsThirdSelection] = React.useState(false);   

    // selectの幅
    const [firstSelectWidth, setFirstSelectWidth] = React.useState(twoSelectWidth);

    // checkbox
    const [isCheck, setIsCheck] = useState(false);
    const [checkVal, setCheckVal] = useState<number[]>([]);
    const [checkedState, setCheckedState] = useState(
      new Array(55).fill(false)
    );

    let categorySecond1: any = [];

    // First Select
    const changeFirst = (event: React.ChangeEvent<{ value: unknown }>) => {
      let selectValue = event.target.value as string;
      let subSubcategory1: any;

      AllCategory.forEach(function (ac1: any) {
        if (ac1[0].category === selectValue) {
          subSubcategory1 = ac1;
          setListCategories(subSubcategory1);
        }
      });

      setCheckedState(new Array(55).fill(false));
      setCheckVal([]);
  
      setFirstSelectWidth(twoSelectWidth);
  
      setSelectFirst(selectValue);
      setIsChangeFirst(!isChangeFirst);
      setIsChangeSecond(!isChangeSecond);
  
      let category1: Categories = {
        category: subSubcategory1[0].category,
        attributes: subSubcategory1[0].attributes,
        field: subSubcategory1[0].field,
      };
  
      setCategory(category1);

      setSelectSecond(subSubcategory1[0].subSubcategory);
      setListCategories3(subSubcategory1);

      if (subSubcategory1[0].subcategory !== "") {
        setExistsThirdSelection(true);
        setFirstSelectWidth(threeSelectWidth);

        setSelectSecond3(subSubcategory1[0].subcategory);
        setSelectThird3(subSubcategory1[0].subSubcategory);

        let a1 = AllCategory.filter((e: any) => {
          if (selectValue === e[0].category) {
            let values1: any = [];

            let b1 = e.filter((e2: any) => {
              if (values1.indexOf(e2["subcategory"]) === -1) {
                values1.push(e2["subcategory"]);
                
                categorySecond1.push({
                  subcategory: e2["subcategory"], 
                  subcategoryLabel: e2["subcategoryLabel"]
                });
              }
            });
          }
        });

        setCategorySecond(categorySecond1);
      } else {
        setExistsThirdSelection(false);
      }
    };
  
    // Second Select
    const changeSecond = (event: React.ChangeEvent<{ value: string, name: string }>) => {
      setIsChangeSecond(!isChangeSecond);
  
      setCheckedState(new Array(55).fill(false));
      setCheckVal([]);
  
      let title: string = event.target.name;
      let targetValue: string = event.target.value;

      setSelectFirst(title);

      let subSubcategory: any;

      AllCategory.forEach(function (ac1: any) {
        if (ac1[0].category === title) {
          setListCategories(ac1);

          ac1.forEach(function (ac2: any) {
            if (ac2.subSubcategory === targetValue) {
              subSubcategory = ac2;
            }
          });
        }
      })

      setSelectSecond(targetValue);

      let category1: Categories = {
        category: subSubcategory.category,
        attributes: subSubcategory.attributes,
        field: subSubcategory.field,
      };
  
      setCategory(category1);
    };

    const changeSecond3 = (event: React.ChangeEvent<{ value: unknown }>) => {
      setCheckedState(new Array(55).fill(false));
      setCheckVal([]);

      setIsChangeSecond(!isChangeSecond);
      setIsChangeThird(!isChangeThird);
  
      let selectValue = event.target.value as string;

      setSelectSecond3(selectValue);

      let subSubcategory1: any;
      let arrThird: any[] = [];

      AllCategory.forEach(function (ac1: any) {
        if (ac1[0].category === selectFirst) {
          subSubcategory1 = ac1;

          ac1.forEach(function (ac2: any) {
            if (ac2.subcategory === selectValue) {
              arrThird.push(ac2);
            }
          })
        }
      })

      setSelectThird3(arrThird[0].subSubcategory);
      setListCategories3(subSubcategory1);

      let category1: Categories = {
        category: arrThird[0].category,
        attributes: arrThird[0].attributes,
        field: arrThird[0].field,
      };
  
      setCategory(category1);
    };

    const changeThird3 = (event: React.ChangeEvent<{ value: unknown }>) => {
      setCheckedState(new Array(55).fill(false));
      setCheckVal([]);
  
      setIsChangeThird(!isChangeThird);
  
      let targetValue: string = event.target.value as string;

      setSelectThird3(targetValue);

      let arrThird: any[] = [];

      AllCategory.forEach(function (ac1: any) {
        if (ac1[0].category === selectFirst) {
          ac1.forEach(function (ac2: any) {
            if (ac2.subSubcategory === targetValue) {
              arrThird.push(ac2);
            }
          });
        }
      })

      let category1: Categories = {
        category: arrThird[0].category,
        attributes: arrThird[0].attributes,
        field: arrThird[0].field,
      };
  
      setCategory(category1);
    };
  
    let filterName: string = type + "-" + cmp1 + "-" + cmp2 + "-";
  
    const handleOnChange = (id: any, position: number) => {
      const updatedCheckedState = checkedState.map((item, index) =>
        index === position ? !item : item
      );
  
      let tempCheckVal: Array<number> = checkVal;
  
      if (updatedCheckedState[position]) {
        tempCheckVal.push(id);
        setCheckVal(tempCheckVal);
      } else {
        tempCheckVal = tempCheckVal.filter(function(v){
          return ! id.includes(v);
        });
        setCheckVal(tempCheckVal);
      }
  
      setIsCheck(!isCheck);
      setCheckedState(updatedCheckedState);
    };

    useEffect(() => {
      if (editId === "0" || items === undefined || items === "" || !bdopen) {
        return;
      }
  
      setFirstSelectWidth(twoSelectWidth);
      setSelectFirst(items.category);
      setIsChangeFirst(!isChangeFirst);
      setIsChangeSecond(!isChangeSecond);

      let allCategory: any = [];
      let subSubcategory: any = [];

      AllCategory.forEach(function (ac1: any) {
        if (ac1[0].category === items.category) {
          
          ac1.forEach(function (ac2: any) {
            if (ac2.subSubcategory === items.subSubcategory) {
              subSubcategory = ac2;
            }
          });
          
          allCategory = ac1;
          setListCategories(ac1);
        }
      })

      setSelectSecond(subSubcategory.subSubcategory);
      setListCategories3(allCategory);

      if (subSubcategory.subcategory !== "") {
        setExistsThirdSelection(true);
        setFirstSelectWidth(threeSelectWidth);

        setSelectSecond3(subSubcategory.subcategory);
        setSelectThird3(subSubcategory.subSubcategory);

        let a1 = AllCategory.filter((e: any) => {
          if (items.category === e[0].category) {
            let values1: any = [];

            let b1 = e.filter((e2: any) => {
              if (values1.indexOf(e2["subcategory"]) === -1) {
                values1.push(e2["subcategory"]);
                
                categorySecond1.push({
                  subcategory: e2["subcategory"], 
                  subcategoryLabel: e2["subcategoryLabel"]
                });
              }
            });
          }
        });

        setCategorySecond(categorySecond1);
      } else {
        setExistsThirdSelection(false);
      }

      if (subSubcategory.length <= 0) {
        return;
      }
  
      let category1: Categories = {
        category: subSubcategory.category,
        attributes: subSubcategory.attributes,
        field: subSubcategory.field,
      };
  
      setCategory(category1);
    }, []);
  
    return (
      <div style={{
        background: "white", 
        border: "0.1rem solid white", 
        borderRadius: "10px", 
        padding: "8px", 
        marginTop: "0px", 
        marginBottom: "10px"
      }}>
        <Link to="#" onClick={() => removeComponents2(cmp2)}>
          <CloseIcon style={{marginBottom: "-8px", marginRight: "8px"}} />
        </Link>
        <Controller
          id={`${filterName}first`}
          name={`${filterName}first`}
          control={control}
          defaultValue={selectFirst}
          key={isChangeFirst ? `${filterName}first-Loading` : `${filterName}first-Loaded`}
          render={({ onChange }) => (
            <Select
              value={selectFirst}
              onChange={changeFirst}
              style={{width: `${firstSelectWidth}`, marginRight: "15px"}}
            >
              {
                FirstCategoryAndLabel.map((category: any, index: number) =>
                  <MenuItem value={category.category} key={index}>{category.categoryLabel}</MenuItem>
                )
              }
            </Select>
          )}
        />
        {existsThirdSelection ? 
          <>
            <Controller
              id={`${filterName}second`}
              name={`${filterName}second`}
              control={control}
              defaultValue={selectSecond3}
              key={isChangeSecond ? `${filterName}2nd-Loading` : `${filterName}2nd-Loaded`}
              render={({ onChange }) => (
                <Select
                  value={selectSecond3}
                  onChange={changeSecond3}
                  style={{width: threeSelectWidth, marginRight: "15px"}}
                >
                  {
                    categorySecond.map((category: any, index: number) =>
                      <MenuItem value={category.subcategory} key={index}>{category.subcategoryLabel}</MenuItem>
                    )
                  }
                </Select>
              )}
            />
            <Controller
              id={`${filterName}third`}
              name={`${filterName}third`}
              control={control}
              defaultValue={selectThird3}
              key={isChangeThird ? `${filterName}3rd-Loading` : `${filterName}3rd-Loaded`}
              render={({ onChange }) => (
                <Select
                  value={selectThird3}
                  onChange={changeThird3}
                  style={{width: threeSelectWidth}}
                >
                  {
                    listCategories3.filter(({ subcategory }) => subcategory === selectSecond3).map((category: any, index: number) =>
                      <MenuItem value={category.subSubcategory} key={index}>{category.subSubcategoryLabel}</MenuItem>
                    )
                  }
                </Select>
              )}
            />
          </>
        :
          <SelectComponents
            nameValue={selectFirst}
            selectValue={selectSecond}
            changeValue={changeSecond}
            categoryValue={listCategories}
            control={control}
            filterName={filterName}
            isChangeSecond={isChangeSecond}
          />
        }
        <br />
        <SetComponents
          category={category}
          control={control}
          handleOnChange={handleOnChange}
          filterName={filterName}
          items={bdopen ? items : ""}
          isCheck={isCheck}
          checkVal={checkVal}
          setCheckVal={setCheckVal}
          checkedState={checkedState}
          setCheckedState={setCheckedState}
          bdopen={bdopen}
        />
      </div>
    );
};

// @ts-ignore
const SetComponents = ({ category, control, handleOnChange, filterName, items, isCheck, checkVal, setCheckVal, checkedState, setCheckedState, bdopen }) => {
  return (
      <>
        {category.field === "multi" ?
          <MultiComponent
              category={category}
              control={control}
              handleOnChange={handleOnChange}
              filterName={filterName}
              items={bdopen ? items : ""}
              isCheck={isCheck}
              checkVal={checkVal}
              setCheckVal={setCheckVal}
              checkedState={checkedState}
              setCheckedState={setCheckedState}
          />
        : category.field === "range" ?
          <RangeComponent
              category={category}
              control={control}
              filterName={filterName}
              items={bdopen ? items : ""}
          />
        : category.field === "text" ?
          <TextComponent
              category={category}
              control={control}
              filterName={filterName}
              items={bdopen ? items : ""}
          />
        : ""}
      </>
  );
}
  
// @ts-ignore
const SelectComponents = ({ nameValue, selectValue, changeValue, categoryValue, control, filterName, isChangeSecond }) => {
    return (
      <Controller
        id={`${filterName}second`}
        name={`${filterName}second`}
        control={control}
        defaultValue={selectValue}
        key={isChangeSecond ? `${filterName}2nd-Loading` : `${filterName}2nd-Loaded`}
        render={({ onChange }) => (
          <Select
            value={selectValue}
            onChange={changeValue}
            name={nameValue}
            style={{width: twoSelectWidth}}
          >
            {
              categoryValue.map((category: any, index: number) =>
                <MenuItem value={category.subSubcategory} key={index}>{category.subSubcategoryLabel}</MenuItem>
              )
            }
          </Select>
        )}
      />
    );
};
  
// @ts-ignore
const MultiComponent = ({ category, control, handleOnChange, filterName, items, isCheck, checkVal, setCheckVal, checkedState, setCheckedState }) => {
    let attributes1: any = category.attributes;
    let keys: string[] = Object.keys(attributes1);
  
    useEffect(() => {
      if (items === undefined || checkVal.length > 0) {
        return;
      }

      if (items === "" || items.field !== "multi" || items.value.length === 0) {
        return;
      }

      const conditionJson = localStorage.getItem(POSEIDON_CONDITION);

      if (conditionJson === null) {
        return;
      }

      const obj = JSON.parse(conditionJson);

      let arrSubSubCategory: any[] = [];

      let b = obj.filter((e: any) => {
        if (e["subSubcategory"] === items.subSubcategory) {
          arrSubSubCategory.push(e);
        }
      });

      let subSubCategory = arrSubSubCategory;
      let indexes: Array<number> = [];
      let index: number = 0;
      let tempCheckVal: number[] = checkVal;
  
      for(let attribute of subSubCategory[0].attributes) {
        let json1: string = JSON.stringify(attribute);
        let splitVal1: string[] = json1.split(",");
        let splitVal2: string[] = splitVal1[1].split(":");
        let conditionValue = splitVal2[1].replace("}", "");
        conditionValue = conditionValue.replace(/"/g, "");
  
        for(let itemValue of items.value) {
          if (itemValue === conditionValue) {
            tempCheckVal.push(itemValue);
            indexes.push(index);
          }
        };
  
        index++;
      };

      setCheckVal(tempCheckVal);
  
      let regexpVal: string = "";
      indexes.map((index: number) => {
        regexpVal += index + "|";
      });
      
      regexpVal = regexpVal.substring(0, regexpVal.length-1);
      regexpVal = "\\b(" + regexpVal + ")\\b";
      let regexp = new RegExp(regexpVal, "g");
  
      let updatedCheckedState = checkedState.map((item: any, index: number) => 
        String(index).match(regexp) ? !item : item
      );
  
      setCheckedState(updatedCheckedState);
    }, []);
  
    return (
      <Controller
        name={`${filterName}answer_multi`}
        control={control}
        defaultValue={checkVal}
        key={isCheck ? "Loading" : "Loaded"}
        as={
          <>
          <Grid 
            container spacing={2} 
            style={{marginTop: "15px"}}
          >
              {
              keys.map((key: any, index: number) => 
                <Grid item xs={3} key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={attributes1[key].value}
                        color="primary"
                        checked={checkedState[index]}
                        onChange={(e) => handleOnChange(e.target.id, index)}
                      />
                    }
                    label={<span style={{fontSize: "18px"}}>{attributes1[key].text}</span>}
                  />
                </Grid>
              )
              }
          </Grid>
          </>
        }
      />
    );
};

// @ts-ignore
const RangeComponent = ({ category, control, filterName, items }) => {
    let step: number = category.attributes[0].step;

    useEffect(() => {

    }, []);
  
    return (
      <div style={{marginTop: "15px"}}>
        <Controller
          name={`${filterName}answer_range1`}
          control={control}
          key={step === 0.1 ? `${filterName}Loading_r1_1` : step === 1 ? `${filterName}Loading_r1_2` : step === 2 ? `${filterName}Loading_r1_3` : `${filterName}Loading_r1_4`}
          defaultValue={items === "" || items === undefined ? "" : items.value[0]}
          as={
            <TextField
              id="outlined-number"
              type="number"
              size="medium"
              style={{marginRight: "20px", width: "30%"}}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: { step: step },
                endAdornment: <InputAdornment position="end">以上</InputAdornment>,
                style: {fontSize: 20},
              }}
            />
          }
        />
        <Controller
          name={`${filterName}answer_range2`}
          control={control}
          key={step === 0.1 ? `${filterName}Loading_r2_1` : step === 1 ? `${filterName}Loading_r2_2` : step === 2 ? `${filterName}Loading_r2_3` : `${filterName}Loading_r2_4`}
          defaultValue={items === "" || items === undefined ? "" : items.value[1]}
          as={
            <TextField
              id="outlined-number"
              type="number"
              style={{width: "30%"}}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                // inputProps: { min: 0, max: 10, step: step },
                inputProps: { step: step },
                endAdornment: <InputAdornment position="end">以下</InputAdornment>,
                style: {fontSize: 20},
              }}
            />
          }
        />
      </div>
    );
};
  
// @ts-ignore
const TextComponent = ({ category, control, filterName, items }) => {
    let placeHolder: string = category.attributes[0].placeholder;
  
    useEffect(() => {
  
    }, []);
  
    return (
      <div style={{marginTop: "15px"}}>
        <Controller
          name={`${filterName}answer_text`}
          control={control}
          key={placeHolder.length < 20 ? "Loading" : "Loaded"}
          defaultValue={items !== "" ? items.value[0] : ""}
          as={
            <TextField
              id="standard-multiline-static"
              multiline
              rows={4}
              placeholder={placeHolder}
              style={{width: "60%", padding: "5px", background: "#F1F1F2"}}
              InputProps={{
                style: {fontSize: 20, lineHeight: "30px"},
              }}
            />
          }
        />
      </div>
    );
};

// Function
function getCategory() {
  const conditionJson2 = localStorage.getItem(POSEIDON_CONDITION);

  if (conditionJson2 === null) {
    return [];
  }

  const obj2: any[] = JSON.parse(conditionJson2);
  let orders1: number[] = [];

  obj2.forEach(function (o2: any) {
    orders1.push(o2.order);
  });

  let tyohuku1 = Array.from(new Set(orders1))
  const orders2 = tyohuku1.sort((a, b) => a - b);
  let totalArr1: any[][] = [];

  orders2.forEach(function (c2: any, index: number) {
    let arr1: any[] = [];
    let b = obj2.filter((e: any) => {
      if (e["order"] === c2) {
        arr1.push(e);
      }
    });
    totalArr1.push(arr1);
  });

  return totalArr1;
}
